import { NavItem } from "src/components/layout/nav/nav-item";
import { Icon } from "src/components/layout/nav/icons/identity-resolution";
import { useEntitlements } from "src/hooks/use-entitlement";
import type { UseSectionHook } from "./types";
import { useSpaceContext } from "src/components/spaces";

export const useIdentityResolutionSection: UseSectionHook = () => {
  const { data: entitlementsData } = useEntitlements(false);

  return {
    title: "Identity Resolution",
    isEnabled: entitlementsData.entitlements.idr,
    links: [
      {
        href: "/idr",
        label: "Get started",
      },
    ],
  };
};

export const IdentityResolution = () => {
  const { isEnabled } = useIdentityResolutionSection();
  const { isInSpace, isPathAccessibleInSpace } = useSpaceContext();

  if (!isEnabled) {
    return null;
  }

  // Hide when in a space and the path is not accessible
  if (isInSpace && !isPathAccessibleInSpace("/idr")) {
    return null;
  }

  return <NavItem href="/idr" icon={Icon} label="Identity Resolution" />;
};
